import React from 'react';
import { Box, Link } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { ColorPalette } from '../config/color-palette';
import { ContentTitle } from '../content-title/content-title';

export interface ChatComplianceBoxProps {
  headerText?: string;
  mainText?: string;
  link?: {
    href: string;
    label: string;
  };
}

export default function ChatComplianceBox({ headerText, mainText, link }: ChatComplianceBoxProps) {
  return (
    <Box
      component="section"
      tabIndex={0}
      aria-label={headerText}
      style={{
        borderRadius: '8px',
        display: 'flex',
        padding: '16px',
        borderColor: ColorPalette.PrimaryMain,
        marginBottom: '26px',
        marginLeft: '10px',
        borderStyle: 'solid',
        borderWidth: 'thin',
        alignItems: 'start',
        marginRight: '-12px',
      }}
    >
      <FontAwesomeIcon icon={faInfoCircle} color={ColorPalette.InfoIcon} size="2x" style={{ marginRight: '20px', marginTop: '5px' }} aria-hidden="true" />
      <Box>
        <ContentTitle>{headerText}</ContentTitle>
        <Box sx={{ whiteSpace: 'pre-line' }}>
          {mainText}
          {link && (
            <Link sx={{ marginLeft: '5px' }} href={link.href} target="_blank" rel="noopener noreferrer" aria-label={`${link.label} (åbner i nyt vindue)`}>
              {link.label}
            </Link>
          )}
        </Box>
      </Box>
    </Box>
  );
}
